import {
  FormControlLabel,
  useTheme,
  Checkbox as MuiCheckbox,
} from '@mui/material';

type CheckboxProps = {
  checkboxText?: string;
  onChange: () => void;
  isChecked: boolean;
};

const Checkbox = ({ onChange, isChecked, checkboxText }: CheckboxProps) => {
  const theme = useTheme();

  if (!checkboxText) return null;

  return (
    <FormControlLabel
      sx={{ marginTop: theme.spacing(2) }}
      control={
        <MuiCheckbox color="primary" checked={isChecked} onChange={onChange} />
      }
      label={checkboxText}
    />
  );
};

export default Checkbox;
